import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import React, { useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import { Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import PageLoading from '../../../components/PageLoader/PageLoading';
import { comparePhotoModule, getContingentItem } from '../ComparePhotoDucks';
import ContingentPassportItem from './ContingentPassportItem';

function ComparePagePassport() {
  const { t } = useTranslation();
  const { id, firstContingentId, secondContingentId } = useParams();
  const location = useLocation();
  const { firstContingentPhotoUrl, secondContingentPhotoUrl } = location.state || {};

  let breadCrumbItems = [
    { name: t('breadcrumbs_home'), href: '/' },
    { name: t('breadcrumbs_comparePhoto'), href: '/comparePhoto' },
    { name: t('comparePhoto_columnResult'), href: `/comparePhoto/result/${id}` },
    { name: t('comparePhoto_contingent') }
  ];
  const dispatch = useDispatch();
  const {
    loadingPassport,
    secondContingent,
    firstContingent,
    firstMeta,
    secondMeta,
    firstInfo,
    secondInfo
  } = useSelector(state => state[comparePhotoModule]);

  useEffect(() => {
    if (firstContingentId && Number(id)) {
      dispatch(getContingentItem(firstContingentId, true));
    }
    if (secondContingent && Number(id)) {
      dispatch(getContingentItem(secondContingentId, false));
    }
  }, [firstContingentId, secondContingentId]);

  return (
    <>
      <PageLoading loading={loadingPassport}>
        <BreadCrumbs items={breadCrumbItems} />
        <Paper style={{ position: 'relative' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              gap: 2
            }}
          >
            <Box sx={{ width: { xs: '100%', md: '50%' } }}>
              {firstContingent && firstContingentPhotoUrl && (
                <ContingentPassportItem
                  meta={firstMeta}
                  data={firstContingent}
                  info={firstInfo}
                  url={firstContingentPhotoUrl}
                />
              )}
            </Box>

            <Box sx={{ width: { xs: '100%', md: '50%' } }}>
              {secondContingent && secondContingentPhotoUrl && (
                <ContingentPassportItem
                  meta={secondMeta}
                  data={secondContingent}
                  info={secondInfo}
                  url={secondContingentPhotoUrl}
                />
              )}
            </Box>
          </Box>
        </Paper>
      </PageLoading>
    </>
  );
}

export default ComparePagePassport;
